import React from 'react'

export default function Container({ children }) {
    return <ul className={'relative z-50 timers-container'}>
        {children}
    </ul>
}